import React from 'react';
import { Container } from '@realm-kf/halcyon-components-react';
import styles from './wrapper.css';
var Wrapper = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles.Wrapper },
        React.createElement(Container, { classes: styles.MainContainer }, children)));
};
export { Wrapper };
